var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { COLORS } from '../../../constants/colors';
export const MobilityFeesRefund = (_a) => {
    var { stroke, fill } = _a, rest = __rest(_a, ["stroke", "fill"]);
    return (_jsx("svg", Object.assign({ width: "18", height: "16", viewBox: "0 0 18 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest, { children: _jsx("path", { d: "M3.72222 8.69428C3.72222 2.02762 7.05556 0.916504 14.8333 0.916504C14.062 3.6163 13.2906 5.51284 12.3333 6.79199M3.72222 8.69428C5.66667 5.9165 7.75 4.24984 9.83333 4.24984M3.72222 8.69428L1.5 10.9165M3.72222 8.69428C6.02533 9.07814 7.79801 9.19677 9.22351 8.86695M13.1667 15.0832H14.4167C15.5675 15.0832 16.5 14.1507 16.5 12.9998C16.5 11.849 15.5675 10.9165 14.4167 10.9165H10.6667M10.6667 10.9165L12.3333 12.5832M10.6667 10.9165L12.3333 9.24984", stroke: stroke !== null && stroke !== void 0 ? stroke : COLORS.PURPLE[900], strokeWidth: "1.25", strokeLinecap: "round", strokeLinejoin: "round" }) })));
};
